import { ComponentProps } from "react";
import { PublishingOutbox } from "@/components/composer/PublishingOutbox";

type OutboxProps = ComponentProps<typeof PublishingOutbox>;

export interface ComposerOutboxPanelProps {
  briefs: OutboxProps["briefs"];
  drafts: OutboxProps["drafts"];
  publications: OutboxProps["publications"];
  connectors: OutboxProps["connectors"];
  canDispatch: OutboxProps["canDispatch"];
  onPromote: OutboxProps["onPromote"];
  onSend: OutboxProps["onSend"];
  onArchive: OutboxProps["onArchive"];
  onCopy: OutboxProps["onCopy"];
  onDownload: OutboxProps["onDownload"];
}

export const ComposerOutboxPanel = (props: ComposerOutboxPanelProps) => {
  return (
    <div className="flex h-full flex-col overflow-y-auto p-3 text-xs">
      <PublishingOutbox {...props} />
    </div>
  );
};
